/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Osproik5Inputs */

const de__field_osproik5 = /** @type {(inputs: _Field_Osproik5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS-Schüler:innen pro Intensivkurs`)
};

/**

* @param {_Field_Osproik5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_osproik5 = /** @type {((inputs?: _Field_Osproik5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Osproik5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_osproik5(inputs)
});
export { _field_osproik5 as "_field_OSProIK" }